<template>
  <NavigationBarTop />
</template>

<script>
import NavigationBarTop from '@/components/NavigationBarTop.vue'

export default {
    components: {
        NavigationBarTop
    }
}
</script>

<style>

</style>